import { Component, OnInit } from '@angular/core';
import { GlobalVariableService } from "../../variables/global-variable";

@Component({
  selector: 'sen-app-copyright-info',
  templateUrl: './copyright-info.component.html',
  styleUrls: ['./copyright-info.component.scss']
})
export class CopyrightInfoComponent implements OnInit {
  version: String;

  constructor(public global: GlobalVariableService) {
    this.version = this.global.formatVersion(this.global.iVersion);
  }

  ngOnInit(): void {
  }

}
